import { BackgroundContainer } from "../BackgroundContainer";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";
import { Utils } from "../../Utils";


    export class StatsState extends Phaser.State {

        public static currentInstance: StatsState;  

        private midContainer: Phaser.Group;
        private resetContainer: Phaser.Group;
        private highscore: Phaser.Text;
        private crosses: Phaser.Text;
        private deaths: Phaser.Text;
        private calls: Phaser.Text;
        private streak: Phaser.Text;
        private warningText: Phaser.Text;
      
        public init(): void {
            
            StatsState.currentInstance = this;
        }
        
        public create(): void {

            const background = new BackgroundContainer(this.game);
            this.add.existing(background);

            const darkLayer = this.add.sprite(0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
            darkLayer.scale.set(GameConstants.GAME_WIDTH / GameConstants.BITMAP_SIZE, GameConstants.GAME_HEIGHT / GameConstants.BITMAP_SIZE);
            darkLayer.inputEnabled = true;
            darkLayer.events.onInputDown.add(this.enterSplashScene, this);
            darkLayer.alpha = .65;

            let onDesktop = !/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent);

            let s =  window.innerWidth / window.innerHeight <= 1.5 && !onDesktop ? .9 : 1;

            this.midContainer = new Phaser.Group(this.game);
            this.midContainer.x = GameConstants.GAME_WIDTH / 2;
            this.midContainer.scale.set(s * GameVars.scaleX, s);
            this.add.existing(this.midContainer);

            const highscoreText = new Phaser.Text(this.game, -140, 60, " High score: ", {font: "26px RoundsBlack", fill: "#FFFFFF"});
            highscoreText.anchor.set(.5);
            highscoreText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(highscoreText);

            const crossesText = new Phaser.Text(this.game, -140, 110, " Successful crosses: ", {font: "26px RoundsBlack", fill: "#FFFFFF"});
            crossesText.anchor.set(.5);
            crossesText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(crossesText);

            const deathsText = new Phaser.Text(this.game, -140, 160, " Total deaths: ", {font: "26px RoundsBlack", fill: "#FFFFFF"});
            deathsText.anchor.set(.5);
            deathsText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(deathsText);

            const callsText = new Phaser.Text(this.game, -140, 210, " Close calls: ", {font: "26px RoundsBlack", fill: "#FFFFFF"});
            callsText.anchor.set(.5);
            callsText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(callsText);

            const streakText = new Phaser.Text(this.game, -140, 260, " Longest streak: ", {font: "26px RoundsBlack", fill: "#FFFFFF"});
            streakText.anchor.set(.5);
            streakText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(streakText);

            const resetButton = new Phaser.Button(this.game, 0, 360, "texture_atlas_1", this.onDownReset, this);
            resetButton.setFrames("btn_reset_on.png", "btn_reset_off.png", "btn_reset_on.png", "btn_reset_off.png");
            resetButton.anchor.set(.5);
            resetButton.forceOut = true;
            this.midContainer.add(resetButton);

            const stats = GameVars.gameData.stats;

            this.highscore = new Phaser.Text(this.game, 140, 60, Utils.formatNumber(stats.highscore), {font: "26px RoundsBlack", fill: "#FFFFFF"});
            this.highscore.anchor.set(.5);
            this.highscore.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(this.highscore);

            this.crosses = new Phaser.Text(this.game, 140, 110, Utils.formatNumber(stats.crosses), {font: "26px RoundsBlack", fill: "#FFFFFF"});
            this.crosses.anchor.set(.5);
            this.crosses.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(this.crosses);

            this.deaths = new Phaser.Text(this.game, 140, 160, Utils.formatNumber(stats.deaths), {font: "26px RoundsBlack", fill: "#FFFFFF"});
            this.deaths.anchor.set(.5);
            this.deaths.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(this.deaths);

            this.calls = new Phaser.Text(this.game, 140, 210, Utils.formatNumber(stats.closeCalls), {font: "26px RoundsBlack", fill: "#FFFFFF"});
            this.calls.anchor.set(.5);
            this.calls.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(this.calls);

            this.streak = new Phaser.Text(this.game, 140, 260, Utils.formatNumber(stats.streak), {font: "26px RoundsBlack", fill: "#FFFFFF"});
            this.streak.anchor.set(.5);
            this.streak.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.midContainer.add(this.streak);

            this.resetContainer = new Phaser.Group(this.game);
            this.resetContainer.visible = false;
            this.resetContainer.x = GameConstants.GAME_WIDTH / 2;
            this.resetContainer.scale.x = GameVars.scaleX;
            this.add.existing(this.resetContainer);

            this.warningText = new Phaser.Text(this.game, 0, GameConstants.GAME_HEIGHT / 2, " WARNING \n This will completely erase all saved scores \n from the game. \n\n Are you sure? \n\n Y/N ", {font: "26px RoundsBlack", fill: "#FFFFFF", align: "center"});
            this.warningText.anchor.set(.5);
            this.warningText.setShadow(1.5, 1.5, "rgba(0,0,0,0.5)", 5);
            this.resetContainer.add(this.warningText);

            this.warningText.text = " WARNING \n This will completely erase all saved scores \n from the game. \n\n Are you sure? \n\n ";

            const yesButton = new Phaser.Button(this.game, -60, GameConstants.GAME_HEIGHT / 2 + 90, "texture_atlas_1", this.onDownYes, this);
            yesButton.setFrames("btn_yes_on.png", "btn_yes_off.png", "btn_yes_on.png", "btn_yes_off.png");
            yesButton.anchor.set(.5);
            yesButton.forceOut = true;
            this.resetContainer.add(yesButton);

            const noButton = new Phaser.Button(this.game, 60, GameConstants.GAME_HEIGHT / 2 + 90, "texture_atlas_1", this.onDownNo, this);
            noButton.setFrames("btn_no_on.png", "btn_no_off.png", "btn_no_on.png", "btn_no_off.png");
            noButton.anchor.set(.5);
            noButton.forceOut = true;
            this.resetContainer.add(noButton);
        }

        public shutdown(): void {
            
            StatsState.currentInstance = null;
            super.shutdown();
        }

        private onDownReset(b: Phaser.Button): void {

            b.clearFrames();

            this.showResetScores();

            AudioManager.playSound("click");
        }

        private onDownYes(b: Phaser.Button): void {

            b.clearFrames();

            this.resetScores();

            AudioManager.playSound("click");
        }

        private onDownNo(b: Phaser.Button): void {

            b.clearFrames();

            this.showStats();

            AudioManager.playSound("click");
        }

        private enterSplashScene(): void {

            GameManager.enterSplashScene();
            AudioManager.playSound("click");
        }

        private showResetScores(): void {

            this.midContainer.visible = false;
            this.resetContainer.visible = true;
        }

        private showStats(): void {

            if (this.resetContainer.visible) {
                this.midContainer.visible = true;
                this.resetContainer.visible = false;
            }
        }

        private resetScores(): void {

            if (this.resetContainer.visible) {
                GameManager.resetStats();
            }
        }
    }
